import React, { useRef, useEffect, useState, useLayoutEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { CarouselProvider, Slider, Slide } from 'pure-react-carousel';
import { Swipeable } from 'react-swipeable';
import { useParams, useHistory } from 'react-router-dom';

import { pbpCardTypes } from '../../models/Models';

import { setPBPBlockScroll, setHasVisitedPBP } from '../../store/reducers/mainReducer';
import NextStory from '../../components/Common/NextStory/NextStory';
import Pulse from '../../components/PoweredByPurpose/Pulse/Pulse';
import TimelineIntro from '../../components/PoweredByPurpose/TimelineIntro/TimelineIntro';
import RelatedStories from '../../components/PoweredByPurpose/RelatedStories/RelatedStories';
import FullScreenCarousel from '../../components/PoweredByPurpose/FullScreenCarousel/FullScreenCarousel';
import VideoIntro from '../../components/PoweredByPurpose/VideoIntro/VideoIntro';
import ExhibitMenu from '../../components/Common/ExhibitMenu/ExhibitMenu';
import { ADAARIARoles, ADALandmarks, ADAWidgitRoles } from '../../models/ADA';
import './PBPHome.scss';
import CardHolder from '../../components/Common/CardHolder/CardHolder';

import { getPBPData, getPBPArray } from '../../models/Utils';

let maxDeltaY = 0;
let checkForScroll = true;

const PBPHome = () => {
  const dispatch = useDispatch();
  const cmsData = useSelector(state => state.data.cms);
  const navbar = useSelector(state => state.data.menus.poweredByPurpose);
  const blockScroll = useSelector(state => state.data.PBPBlockScroll);
  const menuOpened = useSelector(state => state.data.menuOpened);
  const creditsOpened = useSelector(state => state.data.creditsOpened);
  const hasVisitedBBF = useSelector(state => state.data.hasVisitedBBF);
  const [index, setIndex] = useState(0);
  const controlRef = useRef(null);
  let { slideId } = useParams();
  let history = useHistory();
  let [menuDisplay, setMenuDisplay] = useState('menu');
  const pbpArray = getPBPArray(cmsData.poweredByPurpose);
  const storyData = getPBPData(slideId, cmsData.poweredByPurpose, pbpArray, history);
  const [ instantAnimation, setInstantAnimation ] = useState(false);

  const [ showCredits, setShowCredits ] = useState(false);
  const [showBottomNav, setShowBottomNav] = useState(false);

  const goToNextSlide = useCallback(() => {
    if (index < pbpArray.length - 1) {
      setInstantAnimation(false);
      setIndex(index + 1);
    } else {
      setShowBottomNav(true);
    }
    if (index >= pbpArray.length - 2) {
      setShowCredits(true);
    }
  }, [index]);

  const goToPrevSlide = useCallback(() => {
    if (index > 0) {
      if (index < pbpArray.length) {
        setShowCredits(false);
      }
      setShowBottomNav(false);
      setInstantAnimation(false);
      setIndex(index - 1);
    }
  }, [index]);

  useEffect(() => {
    document.title = "The Verizon Story - Powered by Purpose";

    const carouselContext = controlRef && controlRef.current && controlRef.current.context;
    if (!carouselContext) {
      return;
    }
    function onChange() {
      var currentInd = carouselContext.state.currentSlide;
      if (pbpArray && pbpArray.length > currentInd && pbpArray[currentInd] && pbpArray[currentInd].type === pbpCardTypes.TIMELINE) {
        setTimeout(() => dispatch(setPBPBlockScroll(false)), 100);
      }
      if (pbpArray && pbpArray.length > currentInd && pbpArray[currentInd] && pbpArray[currentInd].Menu && pbpArray[currentInd].Menu.Path) {
        history.push(`/${cmsData.poweredByPurpose.Path.Text}/${pbpArray[currentInd].Menu.Path}`);
      }
    }
    carouselContext.subscribe(onChange);
    return () => carouselContext.unsubscribe(onChange);
  }, [controlRef, dispatch]);

  useLayoutEffect(() => {
    const handleScroll = e => {
      // e.preventDefault();
      // e.stopPropagation();
      const scrollThreshold = 0;
      if (checkForScroll && Math.abs(e.deltaX) < Math.abs(e.deltaY)) {
        if (Math.abs(e.deltaY) > Math.abs(maxDeltaY) && Math.abs(maxDeltaY) <= scrollThreshold) {
          maxDeltaY = e.deltaY;
        } else {
          checkForScroll = false;
          if (Math.abs(maxDeltaY) > scrollThreshold && !blockScroll && !creditsOpened) {
            if (maxDeltaY > 0) {
              goToNextSlide();
            } else {
              goToPrevSlide();
            }
          } else if (Math.abs(maxDeltaY) > scrollThreshold) {
            console.log('scroll!!: ', blockScroll);
          }
          maxDeltaY = 0;
          setTimeout(() => {
            checkForScroll = true;
          }, 1000);
        }
      }
    };

    // modern Chrome requires { passive: false } when adding event
    let supportsPassive = false;
    try {
      window.addEventListener(
        'test',
        null,
        Object.defineProperty({}, 'passive', {
          get: function () {
            supportsPassive = true;
          },
        })
      );
    } catch (e) {}

    const wheelOpt = supportsPassive ? { passive: false } : false;
    const wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';
    const AddEvents = () => {
      window.addEventListener(wheelEvent, handleScroll, wheelOpt); // modern desktop
      window.addEventListener('touchmove', handleScroll, wheelOpt); // mobile
      window.addEventListener('keydown', handleScroll, false);
    };
    const RemoveEvents = () => {
      window.removeEventListener(wheelEvent, handleScroll);
      window.removeEventListener('touchmove', handleScroll);
      window.removeEventListener('keydown', handleScroll);
    };
    if(!menuOpened && !blockScroll && !creditsOpened){
      AddEvents();
    } else {
      RemoveEvents();
    }
    return () => {
      RemoveEvents();
    };
  }, [goToNextSlide, goToPrevSlide, blockScroll, menuOpened, creditsOpened]);

  useEffect(() => {
    if (!cmsData.poweredByPurpose || !controlRef.current) {
      return;
    }
    Object.keys(cmsData.poweredByPurpose);
    let i = 0;
    const slides = Object.keys(cmsData.poweredByPurpose)
      .filter(k => k !== 'Key')
      .map(k => {
        if (k === 'Key') return {};
        else {
          return {
            name: k,
            Key: cmsData.poweredByPurpose[k].Key,
            index: i++,
          };
        }
      });

      if(index !== storyData.Index){
        if (storyData.Index >= pbpArray.length - 1) {
          setShowCredits(true);
        } else {
          setShowCredits(false)
        }
        
      }
  }, [cmsData]);

  useEffect(() => {
    dispatch(setHasVisitedPBP(true));
  }, []);

  useEffect(() => {
    const carouselContext = controlRef && controlRef.current && controlRef.current.context;
    if(carouselContext) {
        setInstantAnimation(true);
        setIndex(storyData.Index);
    }
  }, [slideId]);

  useEffect(() => {
    const carouselContext = controlRef && controlRef.current && controlRef.current.context;
    if(carouselContext) {
      const { currentSlide } = carouselContext.getStoreState();
      if(currentSlide !== index){
        carouselContext.setStoreState({ currentSlide: index, disableAnimation: instantAnimation });
      }
    }
  }, [index]);

  const handleSwipeUp = () => {
    if (!blockScroll && !creditsOpened) {
      goToNextSlide();
    }
  };

  const handleSwipeDown = () => {
    if (!blockScroll && !creditsOpened) {
      goToPrevSlide();
    }
  };

  const onCreditsClick = (active) => {
    dispatch(setPBPBlockScroll(active));
  };

  const getSlideByType = (type, slideIndex, i) => {
    let content;
    var isActive = slideIndex === i;
    switch (type) {
      case pbpCardTypes.INTRODUCTION:
        content = <VideoIntro  data={cmsData && cmsData.poweredByPurpose && cmsData.poweredByPurpose.Introduction} active={isActive} />;
        break;
      case pbpCardTypes.PULSE:
        content = <Pulse  content={cmsData && cmsData.poweredByPurpose && cmsData.poweredByPurpose.Pulse} active={isActive} />;
        break;
      case pbpCardTypes.TIMELINE:
        content = (
          <TimelineIntro
            tabIndex={(isActive && menuDisplay !== 'menu') ? 0 : -1}
            content={cmsData && cmsData.poweredByPurpose && cmsData.poweredByPurpose.NetworkMilestones.Introduction}
            goToNextSlide={goToNextSlide}
            goToPrevSlide={goToPrevSlide}
            isActive={isActive}
            timelineIndex={index}
          />
        );
        break;
      case pbpCardTypes.CAROUSEL:
        content = <FullScreenCarousel  data={cmsData && cmsData.poweredByPurpose && cmsData.poweredByPurpose.Carousel} active={isActive} />;
        break;
      case pbpCardTypes.RELATEDSTORIES:
        content = <RelatedStories content={cmsData && cmsData.poweredByPurpose && cmsData.poweredByPurpose.RelatedStories} active={isActive} />;
        break;
    }
    return content;
  };

  return (
    <div className="pbp-home" role={ADALandmarks.Main}>
      <ExhibitMenu title={cmsData && cmsData.poweredByPurpose && cmsData.poweredByPurpose.Introduction && cmsData.poweredByPurpose.Introduction.Title} links={navbar} />
      <CarouselProvider
        orientation="vertical"
        totalSlides={pbpArray.length}
        naturalSlideWidth="100vw"
        naturalSlideHeight="100vh"
        dragStep={1}
        lockOnWindowScroll={true}
        touchEnabled={false}
        dragEnabled={false}
      >
        <Swipeable
          trackTouch={true}
          trackMouse={true}
          onSwipedDown={handleSwipeDown}
          onSwipedUp={handleSwipeUp}
        >
          <Slider classNameAnimation="slow-carousel" moveThreshold="0.1" ref={controlRef} role={ADAARIARoles.None}>
            {pbpArray.map((data, i) => (
              <Slide key={i} index={i} role={ADAARIARoles.None}>
                <CardHolder
                  active={data.Index === index}
                  story={null}
                  currentIndex={i}
                  showProgressBar={false}
                  onArrowClicked={goToNextSlide}
                  hasArrow={i >= 0 && i < pbpArray.length - 1}
                  isLightBg={data.LightBg}
                  isInlineCard={false}
                  cardHeight={"none"}
                >
                  {getSlideByType(data.Type, data.Index, index)}
                </CardHolder>
              </Slide>
            ))}
          </Slider>
        </Swipeable>
      </CarouselProvider>
      {(showBottomNav || showCredits) && 
        <NextStory
          showNext={showBottomNav}
          showCredits={showCredits}
          next={ hasVisitedBBF ? `/${cmsData.digitalMuseum.Path.Text}/` : `/${cmsData.buildingBrighterFutures.Path.Text}/${cmsData.buildingBrighterFutures.Introduction.Menu.Path}`}
          title={ hasVisitedBBF ? cmsData.global.BottomNavbar.UpNext.Stories.Title : cmsData.global.BottomNavbar.UpNext.BBF.Title }
          subtitle={ hasVisitedBBF ? cmsData.global.BottomNavbar.UpNext.Stories.Subtitle : cmsData.global.BottomNavbar.UpNext.BBF.Subtitle }
          onCreditsClick={onCreditsClick}
          />
      }
      
    </div>
  );
};

export default PBPHome;
